import StorylineResource from './Storyline'

export default class HistoricalStoryline extends StorylineResource {
  static endpoint = 'rpc/search_historical_storylines'

  static allFields = [...StorylineResource.requiredFields, 'quarter']
}
